import actions from './action';


const state = {

};

export default {
  namespaced: true,
  state,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/imports/index.js